<!--
Created on 2021-04-16
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-16
-->
<template>
  <div id="page">
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
        <a href="#" data-back-button class="header-title header-subtitle">Back</a>
        <a href="#" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-dark"><i class="fas fa-sun"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-light"><i class="fas fa-moon"></i></a>
        <a href="#" data-menu="menu-main" class="header-icon header-icon-2"><i class="fas fa-bars"></i></a>
    </div>

    <footer-bar activeItem="profile" />
    
    <div class="page-content">
        <div class="page-title page-title-small">
            <h2><a href="#" data-back-button><i class="fa fa-arrow-left"></i></a>Profil</h2>
            <a href="#" data-menu="menu-main" class="bg-fade-highlight-light shadow-xl preload-img" data-src="images/avatars/5s.png"></a>
        </div>
        <div class="card header-card shape-rounded" data-card-height="150">
            <div class="card-overlay bg-highlight opacity-95"></div>
            <div class="card-overlay dark-mode-tint"></div>
            <div class="card-bg preload-img" data-src="images/pictures/20s.jpg"></div>
        </div>

        <div class="card card-style">
          <div class="content">
            <div class="d-flex">
              <div>
                <a href="#" data-menu="menu-main"><img src="images/avatars/5s.png" width="50" class="me-3 bg-highlight rounded-xl"></a>
              </div>
              <div>
                <h2 class="mb-0 pt-1">Viliam Tencer</h2>
                <p class="color-blue-light text-uppercase font-11 mt-n1 mb-3">Obchodník</p>
              </div>
            </div>
            <p>
              Ako obchodník máte oprávnenia, vidieť objednávky a zákazníkov. A môžete aj objednávky vytvoriť a odoslať na servery Dr. Theiss.
            </p>
          </div>
        </div>

        <div class="content mt-n1">
          <div class="row mb-0">
              <div @click="enterPIN()" class="col-4">
                  <div class="card card-style text-center py-3 mx-0 mb-0">
                    <i data-feather="key" data-feather-line="1" data-feather-size="24" data-feather-color="dark-dark" data-feather-bg="gray-fade-light" class="m-auto"></i>
                    <p class="font-13 font-500 mb-n1 mt-2 color-theme">PIN</p>
                  </div>
              </div>
              <a href="#" data-menu="menu-pass" class="col-4">
                  <div class="card card-style text-center py-3 mx-0 mb-0">
                    <i data-feather="unlock" data-feather-line="1" data-feather-size="24" data-feather-color="dark-dark" data-feather-bg="gray-fade-light" class="m-auto"></i>
                    <p class="font-13 font-500 mb-n1 mt-2 color-theme">Heslo</p>
                  </div>
              </a>
              <a href="#" data-menu="menu-logout" class="col-4">
                  <div class="card card-style text-center py-3 mx-0 mb-0">
                    <i data-feather="log-out" data-feather-line="1" data-feather-size="24" data-feather-color="dark-dark" data-feather-bg="gray-fade-light" class="m-auto"></i>
                    <p class="font-13 font-500 mb-n1 mt-2 color-theme">Odhlásiť</p>
                  </div>
              </a>
          </div>
        </div>
      
        <!-- settings card -->
        <div class="card card-style">
          <div class="content">
              <h3 class="mb-2">Nastavenia</h3>
              <p>
                  Môžete si zmeniť rôzne nastavenia aplikácie.
              </p>
              <div class="d-flex no-effect mt-n4" 
                   data-trigger-switch="toggle-id-1" 
                   data-bs-toggle="collapse" 
                   href="#collapseExample1" 
                   role="button" 
                   aria-expanded="false" 
                   aria-controls="collapseExample1">
                  <div class="pt-2 mt-1">
                      <h5 class="font-600 font-14">
                        Automatická synchronizácia
                      </h5>
                  </div>
                  <div class="ms-auto me-4 pe-2">
                      <div class="custom-control ios-switch">
                          <input type="checkbox" class="ios-input" id="toggle-id-1" v-model="isAutoSyncEnabled">
                          <label class="custom-control-label" for="toggle-id-1"></label>
                      </div>
                  </div>
              </div>
              <div class="d-flex no-effect" 
                   data-toggle-theme>
                  <div class="pt-2 mt-1">
                      <h5 class="font-600 font-14">
                        Tmavý mód
                      </h5>
                  </div>
                  <div class="ms-auto me-4 pe-2">
                      <div class="custom-control ios-switch show-on-theme-dark">
                          <input type="checkbox" class="ios-input" id="toggle-id-2" checked data-toggle-theme>
                          <label class="custom-control-label" for="toggle-id-2"></label>
                      </div>
                      <div class="custom-control ios-switch show-on-theme-light">
                          <input type="checkbox" class="ios-input" id="toggle-id-3" data-toggle-theme>
                          <label class="custom-control-label" for="toggle-id-3"></label>
                      </div>
                  </div>
              </div>

          </div>
        </div>

        <!-- footer and footer card-->
        <footer-card class="footer" />
    </div>    
    <!-- end of page content-->

    <main-menu />

    <dr-theiss-page-modal />

    <!-- modal change pass -->
    <div id="menu-pass" class="menu menu-box-modal rounded-m" 
      data-menu-height="260" 
      data-menu-width="310">
      <h1 class="text-center font-700 mt-3 pt-2">Zmena hesla</h1>
      <p class="boxed-text-xl mt-1">
        Zmeniť heslo v mobilnej aplikácií nie je možné, budete presmerovaný na stránky,<br>kde to možné je.
      </p>
      <a href="https://account.live.com/password/reset" target="_blank" class="external-link btn btn-center-m btn-sm shadow-l rounded-s text-uppercase font-900 bg-red-light">Zmeniť heslo</a>
      <p class="color-theme text-center font-10 opacity-30 mt-2 mb-0 pb-0">Budete presmerovaný do externého prehliadača.</p>
    </div>    

    <!-- modal logout -->
    <div id="menu-logout" class="menu menu-box-modal bg-red-dark rounded-m" 
         data-menu-width="310">
        <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times-circle color-white shadow-xl rounded-circle"></i></h1>
        <h1 class="text-center mt-3 color-white font-700">Odhlásiť?</h1>
        <p class="boxed-text-l color-white opacity-70">
          Po odhlásení budú uložené dáta vymazané:<br>databáza, objednávky a podobne.<br>Naozaj sa chcete odhlásiť?
        </p>
        <a href="login.html" class="close-menu btn btn-m btn-center-m button-s shadow-l mb-4 rounded-s text-uppercase font-900 bg-white color-red-dark">odhlásiť</a>
    </div>

    <pin-modal v-model="pin" :title="pinModalTitle" :message="pinMessage" @onEnter="onEnterPin()" />

    <success-modal :message="successMessage" :title="successTitle" />
    <warning-modal :message="errorMessage" title="Nesprávny PIN!" />
  </div>    
</template>

<script>
import { ref, inject } from 'vue'
import FooterBar from '@/components/bars/FooterBar'
import FooterCard from '@/components/cards/FooterCard'
import DrTheissPageModal from '@/components/modals/DrTheissPageModal'
import PinModal from '@/components/modals/PinModal'
import storage from '@/lib/storage'
import auth from '@/lib/auth'
import SuccessModal from '@/components/modals/SuccessModal'
import WarningModal from '@/components/modals/WarningModal'
import MainMenu from '@/components/menus/MainMenu'

export default {
  name: 'Profile',
  components: {
    FooterBar,
    MainMenu,
    FooterCard,
    DrTheissPageModal,
    PinModal,
    SuccessModal,
    WarningModal,
  },
  setup() {
    const isAutoSyncEnabled = ref(storage.getSettings('isAutoSyncEnabled', { value: false }).value || false)
    const appProps = inject('appProps')
    const pinModalTitle = ref('Zadajte PIN')
    const pinMessage = ref('Pre zmenu existujúceho PINu, najprv zadajte váš PIN.')
    const pin = ref('')
    const newPin = ref('')
    const step = ref(1)
    const successMessage = ref('')
    const errorMessage = ref('')
    const successTitle = ref('')

    function enterPIN () {
      step.value = 1
      pin.value = ''
      newPin.value = ''
      pinModalTitle.value = 'Zadajte PIN'
      pinMessage.value = 'Pre zmenu existujúceho PINu, najprv zadajte váš PIN.'
      appProps.$openPinModal()
    }

    function onEnterPin () {
      if (step.value === 3) {
        if (newPin.value === pin.value) {
          setTimeout(function() {
            auth.setPIN(newPin.value)
            newPin.value = ''
            pin.value = ''
            successTitle.value = 'Uložené'
            successMessage.value = 'Nový PIN bol uložený a pri najbližšom prihlásení bude PIN požadovaný.'
            appProps.$openSuccessModal()
          }, 200)
        } else {
          setTimeout(function() {
            errorMessage.value = 'Vložený PIN sa nezhoduje s novým PIN, prosím proces zmeny PIN zopakujte.'
            appProps.$openWarningModal()
          }, 200)
        }
      }
      if (step.value === 2) {
        setTimeout(function() {
          newPin.value = pin.value
          pin.value = ''
          step.value = 3
          pinModalTitle.value = 'Zopakujte PIN'
          pinMessage.value = 'Pre overenie, zopakujte vami zadaný nový PIN.'
          appProps.$openPinModal()
        }, 200)
      }
      if (step.value === 1) {
        if (auth.checkPIN(pin.value)) {
          setTimeout(function() {
            pin.value = ''
            step.value = 2
            pinModalTitle.value = 'Nový PIN'
            pinMessage.value = 'Vytvorte si váš nový PIN.'
            appProps.$openPinModal()
          }, 200)
        } else {
          setTimeout(function() {
            errorMessage.value = 'Vložený PIN nebol správny, prosím proces zmeny PIN zopakujte.'
            appProps.$openWarningModal()
          }, 200)
        }
      }
    }

    return {
      successMessage,
      errorMessage,
      successTitle,
      isAutoSyncEnabled,
      enterPIN,
      onEnterPin,
      pinModalTitle,
      pinMessage,
      pin,
      step
    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
  },
  watch: {
    isAutoSyncEnabled: function (value) {
      storage.setSettings('isAutoSyncEnabled', { value })
    },
  }
}
</script>